import { Box, styled } from "@mui/material";

const GradientBox = styled(Box)(() => ({
  background:
    "linear-gradient(89.89deg, rgba(110, 30, 108, 0.9) 38.88%, rgba(0, 120, 162, 0.9) 105.32%, rgba(79, 179, 205, 0.9) 139.34%)",
  borderRadius: 99,
  backgroundSize: "100% 100px",
  backgroundRepeat: "no-repeat",
  width: "80px",
  height: "5px",
}));

export default GradientBox;
